import * as roles from './roles'

export default [
  {
    id: roles.ROLE_MANAGE,
    formattedMessageId: 'ROLE_ROLE_MANAGE',
  },
  {
    id: roles.SETUP,
    formattedMessageId: 'ROLE_SETUP',
  },
  {
    id: roles.USER_ADD,
    formattedMessageId: 'ROLE_USER_ADD',
  },
  {
    id: roles.LICENSE_MANAGE,
    formattedMessageId: 'ROLE_LICENSE_MANAGE',
  },
  {
    id: roles.GROUP_MANAGE,
    formattedMessageId: 'ROLE_GROUP_MANAGE',
  },
  {
    id: roles.BOARD_MANAGE,
    formattedMessageId: 'ROLE_BOARD_MANAGE',
  },
  {
    id: roles.PUBLIC_MANAGE,
    formattedMessageId: 'ROLE_PUBLIC_MANAGE',
  },
  {
    id: roles.TEMPLATES,
    formattedMessageId: 'ROLE_TEMPLATES',
  },
  {
    id: roles.DOCSOURCE_MANAGE,
    formattedMessageId: 'ROLE_DOCSOURCE_MANAGE',
  },
]
